import {
  commonTableStyles,
  checkboxStyles,
  header
} from "assets/jss/default/components/commonTableStyles";
import {
  onyxGreenColor,
  whiteColor,
  grayColor
} from "assets/jss/default/theme";

export const caseTableStyles = {
  ...commonTableStyles,
  cardMargin: {
    marginTop: 0,
    marginBottom: 20
  },
  tableWrap: {
    display: "block",
    maxWidth: "100%"
  },
  table: {
    width: "100%",
    borderSpacing: 0
  },
  paper: {
    overflowX: "auto"
  },
  oldCaseTableLink: {
    position: "absolute",
    top: 65,
    right: 35
  },
  tableContainer: {
    maxHeight: 500
  },
  settingsContainer: {
    display: "flex",
    padding: [[5, 0, 10, 0]]
  },
  buttonsContainer: {
    flexGrow: 1,
    textAlign: "end"
  },
  ...header
};

export const caseTableOptionsStyles = {
  optionsContainer: {
    width: "fit-content",
    display: "inline-block"
  },
  disabled: {},
  caseTableDialogContent: {
    maxHeight: 500
  },
  preferenceListItem: {
    "&.Mui-selected": {
      backgroundColor: whiteColor
    },
    "&.Mui-selected:hover": {
      backgroundColor: whiteColor
    }
  },
  caseTableDialogSubheader: {
    color: grayColor[20]
  },
  caseTableDialogInputHeader: {
    color: grayColor[20]
  },
  noTableViewSelectedText: {
    marginLeft: 16
  },
  ...checkboxStyles,
  caseTableManageDialogActions: {
    justifyContent: "center",
    padding: 20
  },
  caseTableCreateDialogActions: {
    padding: [[10, 20, 20, 20]]
  },
  caseTableDialogCloseButton: {
    position: "absolute",
    right: 10,
    top: 10
  },
  caseTableLinkButtons: {
    color: onyxGreenColor
  },
  caseTableManageViewDialogTextInput: {
    width: "100%",
    boxSizing: "border-box",
    "& .MuiInput-underline:after": {
      borderBottomColor: onyxGreenColor
    },
    "& .MuiInput-underline:hover:not($disabled):before": {
      borderBottomColor: "#A5D7A7"
    }
  },
  caseTableCreateViewErrorMessage: {
    textAlign: "center",
    paddingTop: 10
  },
  caseTableViewsDialogTextInput: {
    width: "100%",
    "& .MuiInput-underline:after": {
      borderBottomColor: onyxGreenColor
    },
    "& .MuiInput-underline:hover:not($disabled):before": {
      borderBottomColor: "#A5D7A7"
    }
  },
  caseTableDialogHeader: {
    textTransform: "none",
    fontWeight: "bold"
  },
  deleteDialogHeader: {
    textTransform: "none",
    fontWeight: "bold",
    textAlign: "center"
  },
  caseTableOptionsDropDown: {
    minWidth: 200,
    display: "inline-flex",
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color: onyxGreenColor
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: onyxGreenColor
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: onyxGreenColor
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: onyxGreenColor
    }
  },
  caseTableSettingsSubTitle: {
    fontSize: 12
  }
};

export const caseTablePaginationStyles = {
  root: {
    flexShrink: 0,
    marginLeft: 5
  }
};
